module.exports = __webpack_public_path__ + "img/index-slide-bac.7d56b215.png";